jQuery(function ($) {
  var $btn = $("#positions-load-more");
  var $grid = $("#positions-grid");
  if (!$btn.length || !$grid.length) return;

  var loading = false;

  $btn.on("click", function () {
    if (loading) return;
    loading = true;

    var page = parseInt($btn.data("page") || 1, 10);
    var perpage = parseInt($btn.data("perpage") || 4, 10);
    var nonce = $btn.data("nonce");

    $btn.prop("disabled", true);

    $.ajax({
      url: ZendevPositions.ajaxUrl,
      type: "POST",
      dataType: "json",
      data: {
        action: "zendev_positions_load_more",
        nonce: nonce,
        page: page,
        perpage: perpage,
      },
    })
      .done(function (data) {
        if (!data || !data.success) return;

        if (data.data && data.data.html) {
          $grid.append(data.data.html);
        }

        if (data.data && data.data.page) {
          $btn.data("page", data.data.page);
        }

        if (data.data && data.data.has_more === false) {
            $btn.closest(".positions__wrapper__bottom__load-more").remove();
        } else {
          $btn.prop("disabled", false);
        }
      })
      .fail(function (xhr, status, err) {
        console.log(err || status);
        $btn.prop("disabled", false);
      })
      .always(function () {
        loading = false;
      });
  });
});